<template>
  <div>
    <p>Введите код из смс для регистрации в приложении.</p>
    <form id="verficationCodeWrap">
      <input type="tel"
             v-for="(SymbolCode, index) in codeInput"
             v-model="SymbolCode.val"
             v-mask="'#'"
             :ref="'in' + index"
             v-on:keyup="keyHandler($event, index)"
             v-on:focus="clearThisSymbol(index)"
             :key="index"
      >
    </form>
    <p style="color:red">Для получения смс нажмите на ссылку в ИКС</p>
    <img :src="'img/iks.png'" alt="" style="max-width: 90%;">
  </div>
</template>

<script>

  export default {
    name: "verificationCode",
    data() {
      return {
        codeInput: [
          {val: ''},
          {val: ''},
          {val: ''},
          {val: ''},
          {val: ''},
          {val: ''},
        ]
      }
    },
    methods: {
      clearThisSymbol(index) {
        //по фокусу чистим символ в ячейке
        this.codeInput[index].val = '';
      },
      keyHandler(event, index) {
        //если есть символ в ячейке, переходим на следующий
        if (this.codeInput[index].val.length === 1) {
          if (index < (this.codeInput.length - 1)) {
            let nextIndex = 'in' + (index + 1);
            this.$refs[nextIndex][0].focus();
          }
        }
        //если жамкнули удалялку, то переходим в предыдущую ячейку
        if (event.key === 'Backspace' && index > 0) {
          let prevIndex = 'in' + (index - 1);
          this.$refs[prevIndex][0].focus();
        }
      },
      sendVerificationCode(){
        return new Promise((resolve, reject) => {
          this.$myApi.SendRequest({
            action: 'tryLogin',
            code: this.codeFullNumber,
          }, this, 'codeFullNumber', true)
          .then((res) => {
            if (res.Staff_guid != undefined) {
              localStorage.setItem('Staff_guid', res.Staff_guid);
              this.$store.commit('setView', 'accesCode');
              this.$store.commit('setCode', res.Code_x);
              this.$store.commit('hideModal');
              resolve();
            } else {
              reject(res);
            }
          })
          .catch((res) => {
            reject(res);
          });
        });
      }
    },
    watch: {
      codeFullNumber(val, oldVal) {
        //следим за кол-вом символов, как только набираем нужное кол-во дергаем api
        if (val.length === 6) {
          this.$myApi.checkVersion('verification')
          .then(this.sendVerificationCode)
          .catch((res)=>{
            this.$myApi.displayErrors(res, this)
          });
        }
      }
    },
    computed: {
      codeFullNumber() {
        //собираем символы из ячеек в строку
        let t = '';
        this.codeInput.forEach((value) => {
          t += value.val;
        });
        return t;
      }
    },
    mounted() {
      // console.log('mounted verification')

      this.$myApi.checkVersion('verification').then(()=>{
        // console.log('mounted verification then')
        // console.log(localStorage.getItem("Staff_guid") != '' && localStorage.getItem("Staff_guid") !== null)
        // console.log(localStorage.getItem("Staff_guid") != '')
        // console.log( localStorage.getItem("Staff_guid") !== null)

        if (localStorage.getItem("Staff_guid") != '' && localStorage.getItem("Staff_guid") !== null) {
          this.$store.commit('setView', 'accesCode');
        }
      });

    }

  }
</script>

<style scoped>

  #verficationCodeWrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #verficationCodeWrap input {
    width: 10vw;
    height: 10vw;
    font-size: 9vw;
    text-align: center;
  }

</style>
